import { ExportStatus, ExportTypes, TaskType } from '@dev/ee-api/ee-api-models';
import { identity, pickBy } from 'lodash-es';
import { Reducer } from 'redux';
import { ExportsState } from './types';

export const defaultState: ExportsState = {
    statuses: [ExportStatus.Error, ExportStatus.Loading, ExportStatus.Ready, ExportStatus.Expired],
    types: [
        ExportTypes.Log,
        ExportTypes.Contact,
        ExportTypes.Campaign,
        ExportTypes.LinkTracking,
        ExportTypes.Survey,
        ExportTypes.EmailVerification,
        ExportTypes.EmailVerificationList,
        ExportTypes.SingleEmailVerification,
        ExportTypes.UnsubscribeReason,
        ExportTypes.LinkContacts,
    ],
    exporting: false,
    params: null,
    data: null,
    exportsLoading: false,
    activePage: 1,
    exportsPerPage: 25,
    counts: {
        totalCount: 0,
        readyCount: 0,
        loadingCount: 0,
        verifiedCount: 0,
        expiredCount: 0,
        errorCount: 0,
        campaingCount: 0,
        contactCount: 0,
        linktrackingCount: 0,
        logCount: 0,
        surveyCount: 0,
        unsubscribereasonCount: 0,
        singleemailverificationCount: 0,
        emailverificationlistCount: 0,
        linkcontactsCount: 0,
        emailverificationCount: 0,
        channelCount: 0,
    },
    type: TaskType.Export,
    search: null,
};

const reducer: Reducer<ExportsState> = (state: ExportsState = defaultState, action): ExportsState => {
    const { payload } = action;
    switch (action.type) {
        case '@@contacts/CREATE_START':
        case '@@contacts/CREATE_ERROR':
        case '@@contacts/CREATE_SUCCESS':
            return { ...state, ...payload };
        case '@@exports/FILTER_EXPORTS':
        case '@@exports/FETCH_EXPORTS': {
            const params = {
                activePage: payload.activePage,
                exportsPerPage: payload.exportsPerPage,
                types: payload.types,
                statuses: payload.statuses,
                search: payload.search,
            };
            const injectToStore = pickBy(params, identity);
            return {
                ...state,
                search: payload.search,
                ...injectToStore,
            };
        }
        case '@@exports/FETCH_EXPORTS_START':
            return { ...state, exportsLoading: true };
        case '@@exports/FETCH_EXPORTS_SUCCESS':
            return { ...state, exportsLoading: false, exportsList: payload.exportsList, counts: payload.counts };
        case '@@exports/FETCH_EXPORTS_ERROR':
            return { ...state, exportsLoading: false };
        case '@@exports/SEARCH_EXPORTS':
            return { ...state, search: payload.search, statuses: payload.statuses, types: payload.types };
        case '@@exports/RESTORE_DEFUALT_STORE':
            return defaultState;
        default:
            return state;
    }
};

export { reducer as exports };

export default reducer;
